// src/admin/AdminOrders.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const STATUSES = [
  { key: 'all',       label: 'Toutes' },
  { key: 'pending',   label: 'En attente' },
  { key: 'confirmed', label: 'Confirmées' },
  { key: 'shipped',   label: 'Expédiées' },
  { key: 'delivered', label: 'Livrées' },
  { key: 'cancelled', label: 'Annulées' },
];

function AdminOrders() {
  const navigate = useNavigate();
  const [orders, setOrders]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState('all');
  const [search, setSearch]   = useState('');

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const { data } = await axios.get('https://madadline.com/api/orders', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrders(Array.isArray(data) ? data : []);
    } catch {
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchOrders(); }, []);

  const statusLabel = (s) => ({
    pending:    'En attente',
    confirmed:  'Confirmée',
    prepared:   'Préparée',
    shipped:    'Expédiée',
    delivered:  'Livrée',
    cancelled:  'Annulée',
  }[s] || s);

  const filtered = orders.filter(o => {
    if (filter !== 'all' && o.status !== filter) return false;
    if (search) {
      const q = search.toLowerCase();
      const match =
        String(o.id).includes(q) ||
        (o.user?.name || o.customer_name || '').toLowerCase().includes(q) ||
        (o.city || '').toLowerCase().includes(q);
      if (!match) return false;
    }
    return true;
  });

  const totalCA = orders
    .filter(o => o.status !== 'cancelled')
    .reduce((sum, o) => sum + parseFloat(o.total || 0), 0);

  return (
    <div className="admin-orders">

      <header className="admin-page-head">
        <div>
          <h1>Commandes</h1>
          <p>
            {orders.length} commande{orders.length > 1 ? 's' : ''} · CA : {totalCA.toFixed(0)} DH
          </p>
        </div>
      </header>

      {/* Filtres */}
      <div className="admin-filters">
        <input
          type="text"
          placeholder="Rechercher par n°, cliente ou ville..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="admin-input"
        />
        <div className="admin-status-filters">
          {STATUSES.map(s => (
            <button
              key={s.key}
              className={`admin-chip ${filter === s.key ? 'is-active' : ''}`}
              onClick={() => setFilter(s.key)}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      {/* Table */}
      {loading ? (
        <div className="admin-loading"><div className="spinner" /></div>
      ) : filtered.length === 0 ? (
        <p className="admin-empty">Aucune commande trouvée.</p>
      ) : (
        <div className="admin-card">
          <table className="admin-table">
            <thead>
              <tr>
                <th>N°</th>
                <th>Cliente</th>
                <th>Ville</th>
                <th>Total</th>
                <th>Statut</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(o => (
                <tr key={o.id}>
                  <td><strong>#{o.id}</strong></td>
                  <td>
                    <div className="admin-table__user">
                      <span className="admin-table__avatar">
                        {(o.user?.name || o.customer_name || 'C').charAt(0).toUpperCase()}
                      </span>
                      <span>{o.user?.name || o.customer_name || '—'}</span>
                    </div>
                  </td>
                  <td>{o.city || '—'}</td>
                  <td><strong>{parseFloat(o.total || 0).toFixed(0)} DH</strong></td>
                  <td>
                    <span className={`admin-badge admin-badge--${o.status || 'pending'}`}>
                      {statusLabel(o.status)}
                    </span>
                  </td>
                  <td>{new Date(o.created_at).toLocaleDateString('fr-FR')}</td>
                  <td>
                    <button
                      onClick={() => navigate(`/admin/commandes/${o.id}`)}
                      className="admin-btn-sm admin-btn-sm--edit"
                    >
                      Détails
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminOrders;